import Thumbnail from './thumbnail.jpg';

const title = 'Path Tracer';
const description = `A path tracer written in C++ for CSCI 2240: Interactive Computer Graphics.`;

export default {
  title,
  description,
  thumbnail: Thumbnail,
};
